const PlayIcon = (props: { className?: string }) => {
  return (
    <svg className={`${props.className ?? ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
      <circle cx="19" cy="19" r="18.5" className="fill-primary stroke-accent" />
      <path d="M14 25.7876V12.2124C14 11.24 15.1437 10.6646 15.9876 11.2124L26.4448 18C27.1851 18.4804 27.1851 19.5196 26.4448 20L15.9876 26.7876C15.1437 27.3354 14 26.76 14 25.7876Z" className="fill-white" />
    </svg>
  );
}

export default PlayIcon;